import { useMemo } from "react";

export interface MondaySourceSettingsText {
  boardLabelText: string;
  boardPlaceholderText: string;
  boardHintText: string;
  statusColumnLabelText: string;
  statusColumnPlaceholderText: string;
  statusColumnHintText: string;
  statusesLabelText: string;
  statusesPlaceholderText: string;
  statusesHintText: string;
  doneStatusLabelText: string;
  doneStatusPlaceholderText: string;
  doneStatusHintText: string;
  assignedToMeLabelText: string;
  ownerColumnLabelText: string;
  ownerColumnPlaceholderText: string;
  ownerColumnHintText: string;
  dueDateColumnLabelText: string;
  dueDateColumnPlaceholderText: string;
  dueDateColumnHintText: string;
  loadingText: string;
  loadErrorText: string;
}

export const useMondaySourceSettingsText = (
  t: (key: string) => string,
): MondaySourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.monday.${key}`);

    return {
      boardLabelText: tKey("boardLabel"),
      boardPlaceholderText: tKey("boardPlaceholder"),
      boardHintText: tKey("boardHint"),
      statusColumnLabelText: tKey("statusColumnLabel"),
      statusColumnPlaceholderText: tKey("statusColumnPlaceholder"),
      statusColumnHintText: tKey("statusColumnHint"),
      statusesLabelText: tKey("statusesLabel"),
      statusesPlaceholderText: tKey("statusesPlaceholder"),
      statusesHintText: tKey("statusesHint"),
      doneStatusLabelText: tKey("doneStatusLabel"),
      doneStatusPlaceholderText: tKey("doneStatusPlaceholder"),
      doneStatusHintText: tKey("doneStatusHint"),
      assignedToMeLabelText: tKey("assignedToMeLabel"),
      ownerColumnLabelText: tKey("ownerColumnLabel"),
      ownerColumnPlaceholderText: tKey("ownerColumnPlaceholder"),
      ownerColumnHintText: tKey("ownerColumnHint"),
      dueDateColumnLabelText: tKey("dueDateColumnLabel"),
      dueDateColumnPlaceholderText: tKey("dueDateColumnPlaceholder"),
      dueDateColumnHintText: tKey("dueDateColumnHint"),
      loadingText: tKey("loading"),
      loadErrorText: tKey("loadError"),
    };
  }, [t]);
};
